import { Badge, Box, Heading, Highlight, Image,useColorMode,useColorModeValue } from '@chakra-ui/react'
import React from 'react'
import photo  from '../Components/assets/myphoto.png'
import {useEffect} from 'react'
import Aos from 'aos'
import "aos/dist/aos.css"
const Mystory = () => {

  const { colorMode, toggleColorMode } = useColorMode();

  useEffect(() => {
    Aos.init({duration:1000})
   
  }, [])



  return (
    <div id="about" className="about section" data-aos="fade-left">
        <h1  style={{textAlign:"center",fontSize:"50px"}} data-aos="zoom-out-up">About</h1>
    <div style={{backgroundColor:"black",marginTop:"20px",padding:"20px"}}>
    <div style={{display:"flex"}}>

<Image class="home-img" src={photo} mt={"40px"} alt="" id='photo' style={{backgroundColor:"black", width:"300px",height:"300px",display:"block",margin:"auto",border:"2px solid black",borderRadius:"50%"}} />
    </div>
    <Heading  mt={5} as='h3' size='lg' lineHeight='tall'  style={{textAlign:"center"}}>
  <h2  id="user-detail-name"
  style={{color:"white"}}
  
  data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="100">
    Uzair
  </h2>
</Heading>
    <Heading as='h3' size='lg' lineHeight='tall'  style={{textAlign:"center"}}>
      <Badge colorScheme='teal' style={{ color:colorMode == 'light' ?"black":"white",borderRadius:"10px",padding:"10px",marginTop:"20px"}} fontSize={"20px"}>Full Stack Web Developer</Badge> 
  
</Heading>
<h1></h1>
<h1 style={{textAlign:"center"}}></h1>
<div id="user-detail-intro" className='myself' style={{width:"80%",fontSize:"20px",backgroundColor:"black",color:"white",margin:"auto",padding:"20px"}} >
A Passionate Full Stack Web Developer with hands-on
experience in developing scalable websites/application
using a wide range of frontend and backend skills like
HTML,CSS,Javascript. Highly skilled in design,
development and implementation of functional
specifications.I have done my Higher Secondary Education from Goverment Boys Senior Secondary School.
</div>
    </div>
    </div>
  )
}

export default Mystory